import React from 'react';
import './MProjects.css';
const MProjects = ({ mproject }) => {
    const { about, repo, name, data } = mproject;

    return (
        <div class="col d-flex justify-content-center m-card-grandpa">
            <div>
                <div class="card m-card-container">
                    <div class="card-body m-card-content">
                        <h5 class="card-title title-name">{name}</h5>
                        <p class="card-text card-para">{about}</p>
                        <a href={data} target="_blank" ><button className="click-me-btn">Dataset Link</button></a>
                        <a href={repo} target="_blank" ><button className="click-me-btn">Github</button></a>
                    </div>
                </div>
            </div>
        </div>
    );
};

export default MProjects;